import api from 'api/api'

export const GET_PAYMENT_TYPES = '[PAYMENT TYPES] GET PAYMENT TYPES'
export const GET_PAYMENT_MEANS = '[PAYMENT MEANS] GET PAYMENT MEANS'

export function getPaymentTypesAction() {
  const request = api.get('/payment-types')
  return (dispatch) => {
    dispatch({ type: GET_PAYMENT_TYPES, payload: { loading: true } })
    request.then(({ data }) => {
      dispatch({ type: GET_PAYMENT_TYPES, payload: { data: data.data } })
    }).catch((error) => {
      console.log(GET_PAYMENT_TYPES, error)
    }).finally(() => {
      dispatch({ type: GET_PAYMENT_TYPES, payload: { loading: false } })
    })
  }
}

export function getPaymentMeansAction() {
  const request = api.get('/payment-means')
  return (dispatch) => {
    dispatch({ type: GET_PAYMENT_MEANS, payload: { loading: true } })
    request.then(({ data }) => {
      dispatch({ type: GET_PAYMENT_MEANS, payload: { data: data.data } })
    }).catch((error) => {
      console.log(GET_PAYMENT_MEANS, error)
    }).finally(() => {
      dispatch({ type: GET_PAYMENT_MEANS, payload: { loading: false } })
    })
  }
}